module.exports = __webpack_public_path__ + "assets/img/modal-avatar-2fe1f9c4.png";